import { Link } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';

import { LockOutlined, UserOutlined } from '@ant-design/icons';
import { Button, Card, Checkbox, Form, Input, Typography } from 'antd';

import MainLayout from '@/components/PatientLayout/MainLayout';
import { post } from '@/libs/axios';

const { Title } = Typography;

const PatientSignIn = () => {
  const themeColor = localStorage.getItem('themeColor');
  const navigate = useNavigate();

  const onFinish = async (values) => {
    const res = await post('sessions', values);
    console.log('Received values:', values, res);
    // Here you would handle the password reset request

    localStorage.setItem('Authorization', res.data.auth_token);
    localStorage.setItem('Email', res.data.email);
    localStorage.setItem('point_of_contact', res.data.patient_first_name);
    localStorage.setItem('business_name', res.data.business_name);
    navigate('/claim_status');
  };

  return (
    <MainLayout>
      <div className="my-5 py-5 flex justify-center items-center min-h-[50vh]">
        <Card
          style={{
            width: 450,
            boxShadow: '0 10px 25px rgba(0, 0, 0, 0.1)',
            borderRadius: 8,
          }}
        >
          <div style={{ padding: '20px 40px' }}>
            <Title level={2} style={{ textAlign: 'center', marginBottom: 32, color: themeColor }}>
              Patient Sign In
            </Title>
            <Form name="normal_login" initialValues={{ remember: true }} onFinish={onFinish}>
              <Form.Item
                name="email"
                rules={[{ required: true, message: 'Please input your Email!' }]}
              >
                <Input
                  prefix={<UserOutlined />}
                  placeholder="Email Address"
                  style={{ height: 50, borderRadius: 4 }}
                />
              </Form.Item>
              <Form.Item
                name="password"
                rules={[{ required: true, message: 'Please input your Password!' }]}
              >
                <Input
                  prefix={<LockOutlined />}
                  type="password"
                  placeholder="Password"
                  style={{ height: 50, borderRadius: 4 }}
                />
              </Form.Item>
              <Form.Item>
                <Form.Item name="remember" valuePropName="checked" noStyle>
                  <Checkbox>Remember me</Checkbox>
                </Form.Item>
              </Form.Item>

              <Form.Item>
                <Button
                  type="primary"
                  htmlType="submit"
                  block
                  style={{
                    height: 40,
                    fontSize: 18,
                    fontWeight: 500,
                    borderRadius: 4,
                    background: themeColor,
                    border: 'none',
                    boxShadow: '0 4px 6px',
                  }}
                >
                  Sign in
                </Button>
              </Form.Item>
              <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: 16 }}>
                <Link to="/patient/signup">Patient Register</Link>
                <Link to="/patient/forgot-password">Forgot password?</Link>
              </div>
            </Form>
          </div>
        </Card>
      </div>
    </MainLayout>
  );
};

export default PatientSignIn;
